/*eslint-disable*/
import { useGet } from "./useRequest";

const Geo = "GEO";
const FAILED_RETRY_AFTER_MS = 60 * 1000;

// Countries/states/cities/postcodes are static reference data. Share one request per path
// across all Address instances and re-renders, so concurrent callers reuse the in-flight call.
// fetcher resolves (not rejects) on failure with an Error that has no data, so failures are
// remembered for a short while to stop render loops from hammering the Geo API.
const geoCache = new Map();

const cachedGeoGet = (path) => {
  const cached = geoCache.get(path);
  if (cached && (!cached.failedAt || Date.now() - cached.failedAt < FAILED_RETRY_AFTER_MS)) {
    return cached.promise;
  }

  const entry = { failedAt: null };
  entry.promise = useGet(path, Geo).then((result) => {
    if (!result?.data) {
      entry.failedAt = Date.now();
    }
    return result;
  });
  geoCache.set(path, entry);
  return entry.promise;
};

export const loadCountries = () => {
  const path = "/country";
  return cachedGeoGet(path);
};

export const loadStates = (country) => {
  const path = "/state/" + country;
  return cachedGeoGet(path);
};

export const loadCitiesByCountryStateCode = (country, state) => {
  const path = `/city/${country}/state?statecode=${state}`;
  return cachedGeoGet(path);
};


export function loadCities(state) {
  const path = "/city/" + state;
  return cachedGeoGet(path);
}


export function loadZipCodes(state, city) {
  const path = "/postalcode/" + state + "?placeName=" + city;
  return cachedGeoGet(path);
}


export function loadZipCodesByCountry(country, state, city) {
  const path = `/postalcodebycountry/${country}?stateCode=${state}&placeName=${city}`;
  return cachedGeoGet(path);
}

export function searchLocations(query) {
  const path = "/search?query=" + query;
  const response = useGet(path, Geo);
  return response;
}
